import { render, staticRenderFns } from "./TypeBanner.vue?vue&type=template&id=2f49b390&"
import script from "./TypeBanner.vue?vue&type=script&lang=js&"
export * from "./TypeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports